import React from 'react'
import styled from 'styled-components/macro'
import { Checkbox, FormControl, withStyles } from '@material-ui/core'
import { keyframes } from '@mui/system';



export const CustomFormGroup = styled(FormControl)`
    p,
    b {
        margin: 0;
        /* color: #333333; */
        color:  ${({ hasErrors }) => hasErrors ? '#f44336' : '#333333'};
        font: normal normal normal 13px/21px Roboto; 

        a {
            color:${({ hasErrors }) => hasErrors ? '#f44336' : 'rgb(57, 57, 59)'};
        }
    }

    & .MuiFormControlLabel-root {
        gap: 10px;
        margin: 0px;
    }
`

export const CValeCheckbox = withStyles(({ themeColor }) => {
    return {
        root: {
            padding: '0px',
            color: themeColor?.navigation?.buttons?.backgroundColor,
            '&$checked': {
                color: themeColor?.navigation?.buttons?.backgroundColor,
                fontSize: '14px !important',
            },
        },
        label: {
            margin: 0,
        },
        checked: {},
    }
})((props) => (
    <Checkbox
        color="default"
        {...props}
        disableRipple
        disableTouchRipple
        disableFocusRipple
        viewBox={'0 0 14px 14px'}
    />
))

export const CustomDiv = styled.div`
    @media screen and (max-width: 425px) {
        height: 180px;
    }
`

export const shake = keyframes`
0% { transform: translateX(0); }
20% { transform: translateX(-5px); }
40% { transform: translateX(5px); }
60% { transform: translateX(-5px); }
80% { transform: translateX(5px); }
100% { transform: translateX(0); }
`;


